/**
 * Global cart state seed + synchronizer (optimized)
 * - Seeds window.__CART_STATE from <script id="InitialCartJSON"> or <script id="CartStateJSON">
 * - Emits "cart:state" CustomEvent on updates
 * - Subscribes to theme cart updates and Rebuy updates
 */
(() => {
  const setCartState = (nextCart) => {
    window.__CART_STATE = nextCart;
    document.dispatchEvent(new CustomEvent('cart:state', { detail: nextCart }));
  };

  const seedCartState = () => {
    const alreadySeeded = Array.isArray(window.__CART_STATE?.items);
    if (alreadySeeded) return;

    const initialEl = document.getElementById('InitialCartJSON');
    const drawerEl  = document.getElementById('CartStateJSON');

    let seededCart = { items: [] };
    try {
      if (initialEl?.textContent) {
        seededCart = JSON.parse(initialEl.textContent);
      } else if (drawerEl?.textContent) {
        seededCart = JSON.parse(drawerEl.textContent);
      }
    } catch { /* ignore malformed JSON and fall back to empty cart */ }

    setCartState(Array.isArray(seededCart?.items) ? seededCart : { items: [] });
  };

  const subscribeThemeCartUpdates = () => {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return;
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      const nextCart = event?.data?.cartData;
      if (nextCart) setCartState(nextCart);
    });
  };

  const subscribeRebuyCartUpdates = () => {
    document.addEventListener('rebuy:cart.change', (event) => {
      const rb = event?.detail?.cart;
      if (!rb) return;

      const rawItems = (typeof rb.items === 'function' ? rb.items() : rb.items) || [];
      const items = rawItems.map((it) => ({
        selling_plan_allocation: it.selling_plan_allocation || null,
        id: it.id ?? it.variant_id,
        variant_id: it.variant_id ?? it.id,
        quantity: it.quantity ?? 1,
        title: it.product_title ?? it.title
      }));

      const itemCount = rb.cart?.item_count ?? items.reduce((sum, x) => sum + (x.quantity || 0), 0);
      const totalPrice = rb.cart?.total_price ?? 0;

      setCartState({ items, item_count: itemCount, total_price: totalPrice });
    });
  };

  const init = () => {
    seedCartState();
    subscribeThemeCartUpdates();
    subscribeRebuyCartUpdates();
  };

  (document.readyState === 'loading')
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
})();
